import Vue from 'vue'
import Router from 'vue-router'
import SignIn from './views/SignIn.vue'
import EcHome from './views/EcHome.vue'
import EcProducts from './views/EcProducts.vue'
import EcAbout from './views/EcAbout.vue'
import store from './store'
Vue.use(Router)

const checkIsAdmin = (to, from, next) => {
  console.log('checkIsAdmin')
  const currentUser = store.state.currentUser
  if (currentUser.role !== 'admin') {
    next('/admin/signin')
    return
  }
  next()
}

const checkIsAuthenticated = (to, from, next) => {
  if (!store.state.isLogin) {
    next('/signin')
    return
  }
  next()
}

const router = new Router({
  linkExactActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    // Restore scroll position when navigating back (with delay for content loading)
    if (savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 300)
      })
    }
    // Scroll to top for new page visits
    return { x: 0, y: 0 }
  },

  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: EcHome
    },
    {
      path: '/about',
      name: 'about',
      component: EcAbout
    },
    {
      path: '/signin',
      name: 'sign-in',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'sign-up',
      component: () => import('./views/SignUp.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '/auth/callback',
      name: 'auth-callback',
      component: () => import('./views/AuthCallback.vue')
    },
    {
      path: '/products',
      name: 'products',
      component: EcProducts
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('./views/EcCart.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/EcProfile.vue'),
      beforeEnter: checkIsAuthenticated
    },
    {
      path: '/order/create',
      name: 'orderCreate',
      component: () => import('./views/OrderCreate.vue')
    },
    {
      path: '/order',
      name: 'orderDetail',
      component: () => import('./views/OrderDetail.vue')
    },
    {
      path: '/order/success',
      name: 'order-success',
      component: () => import('./views/OrderSuccess.vue')
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('./views/EcPayment.vue')
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: () => import('./views/PaymentSuccess.vue')
    },
    {
      path: '/payment/failed',
      name: 'payment-failed',
      component: () => import('./views/PaymentFailed.vue')
    },
    {
      path: '/payment/pending',
      name: 'payment-pending',
      component: () => import('./views/PaymentPending.vue')
    },
    {
      path: '/payment/callback',
      name: 'payment-callback',
      redirect: () => {
        // This route is handled by the NewebPay callback Edge Function
        // It will redirect to success/failed/pending pages
        return '/payment/pending'
      }
    },
    {
      path: '/products/:productId',
      name: 'product',
      component: () => import('./views/EcProduct.vue')
    },
    // Footer pages
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/FAQ.vue')
    },
    {
      path: '/return-policy',
      name: 'return-policy',
      component: () => import('./views/ReturnPolicy.vue')
    },
    {
      path: '/shipping-info',
      name: 'shipping-info',
      component: () => import('./views/ShippingInfo.vue')
    },
    {
      path: '/size-guide',
      name: 'size-guide',
      component: () => import('./views/SizeGuide.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('./views/PrivacyPolicy.vue')
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () => import('./views/TermsOfService.vue')
    },
    {
      path: '/admin',
      exact: true,
      redirect: '/admin/products'
    },
    {
      path: '/admin/signup',
      name: 'admin-signup',
      component: () => import('./views/admin/AdminSignUp.vue')
    },
    {
      path: '/admin/signin',
      name: 'admin-signin',
      component: () => import('./views/admin/AdminSignIn.vue')
    },
    {
      path: '/admin/products',
      name: 'admin-products',
      component: () => import('./views/admin/AdminProducts.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/products/new',
      name: 'admin-products-new',
      component: () => import('./views/admin/AdminProductNew.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/drafts',
      name: 'admin-drafts',
      component: () => import('./views/admin/AdminDraftProducts.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/products/:productId',
      name: 'admin-product',
      component: () => import('./views/admin/AdminProduct.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/products/:productId/edit',
      name: 'admin-product-edit',
      component: () => import('./views/admin/AdminProductEdit.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/categories',
      name: 'admin-categories',
      component: () => import('./views/admin/AdminCategories.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/banners',
      name: 'admin-banners',
      component: () => import('./views/admin/AdminBanners.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/coupons',
      name: 'admin-coupons',
      component: () => import('./views/admin/AdminCoupons.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/coupons/new',
      name: 'admin-coupons-new',
      component: () => import('./views/admin/AdminCouponNew.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/coupons/:couponId',
      name: 'admin-coupon',
      component: () => import('./views/admin/AdminCoupon.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/coupons/:couponId/edit',
      name: 'admin-coupon-edit',
      component: () => import('./views/admin/AdminCouponEdit.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/discounts',
      name: 'admin-discounts',
      component: () => import('./views/admin/AdminDiscounts.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/discounts/new',
      name: 'admin-discounts-new',
      component: () => import('./views/admin/AdminDiscountNew.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/discounts/:discountId',
      name: 'admin-discount',
      component: () => import('./views/admin/AdminDiscount.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/discounts/:discountId/edit',
      name: 'admin-discount-edit',
      component: () => import('./views/admin/AdminDiscountEdit.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/orders',
      name: 'admin-orders',
      component: () => import('./views/admin/AdminOrders.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/orders/:orderId',
      name: 'admin-order',
      component: () => import('./views/admin/AdminOrder.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/inventory/alerts',
      name: 'admin-inventory-alerts',
      component: () => import('./views/admin/AdminInventoryAlerts.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/reports/sales',
      name: 'admin-sales-report',
      component: () => import('./views/admin/AdminSalesReport.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('./views/admin/AdminUsers.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/analytics/products',
      name: 'admin-product-analytics',
      component: () => import('./views/admin/AdminProductAnalytics.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '/admin/analytics/customers',
      name: 'admin-customer-analytics',
      component: () => import('./views/admin/AdminCustomerAnalytics.vue'),
      beforeEnter: checkIsAdmin
    },
    {
      path: '*',
      name: 'not-found',
      component: () => import('./views/NotFound.vue')
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (to.path.indexOf('admin') < 0) {
    next()
    return
  }

  if (!store.state.token) {
    await store.dispatch('fetchCurrentUser')
  }
  next()
})

// Update page title based on route
router.afterEach((to) => {
  const baseTitle = 'Point of Demon Shop'
  const routeTitles = {
    'home': '首頁',
    'products': '商品列表',
    'product': '商品詳情',
    'cart': '購物車',
    'order-create': '建立訂單',
    'profile': '個人資料',
    'signin': '登入',
    'signup': '註冊',
    'admin-dashboard': '管理後台 - 儀表板',
    'admin-products': '管理後台 - 商品管理',
    'admin-orders': '管理後台 - 訂單管理',
    'admin-coupons': '管理後台 - 優惠券管理',
    'admin-signin': '管理員登入'
  }

  const pageTitle = routeTitles[to.name] || ''
  document.title = pageTitle ? `${pageTitle} - ${baseTitle}` : baseTitle
})

// Disable browser's native scroll restoration - let Vue Router handle it
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

export default router
